import { createClient } from '@supabase/supabase-js';

const getSupabaseUrl = () => {
  const envUrl = import.meta.env.VITE_SUPABASE_URL;
  // Ignore legacy cloud Supabase URLs if present in build environment
  if (envUrl && !envUrl.includes('.supabase.co')) {
    return envUrl;
  }
  // Always route through HTTPS /api proxy -> self-hosted database (76.13.195.41:54321)
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }
  return '/api';
};

const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY &&
  !import.meta.env.VITE_SUPABASE_ANON_KEY.startsWith('eyJ')
    ? import.meta.env.VITE_SUPABASE_ANON_KEY
    : 'sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH';

export const supabase = createClient(getSupabaseUrl(), supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});